import { Dispatch } from 'redux';

import { waitAsync } from '#/lib/promiseTools';

import {
  ReduxActions,
  ReduxState,
  useSelector,
  useDispatch,
} from './storeCore';
import { getStore } from './storeSetup';

export { useSelector, useDispatch };

/**
 * Because eslint will not resolve `useDispatch` as stable,
 * we need to use this method to get dispatch instance.
 *
 * Do NOT recommended to use OUTSIDE OF COMPONENTS.
 *
 * See https://github.com/facebook/react/issues/16873 https://github.com/Shopify/eslint-plugin-shopify/issues/310
 * Also see https://stackoverflow.com/questions/58624200/react-hook-useeffect-has-a-missing-dependency-dispatch
 */
export const staticDispatch: Dispatch<ReduxActions> = (...params) => {
  const store = getStore();
  if (!store) {
    console.error('Store not yet initialized, delaying dispatch');
    setTimeout(() => {
      getStore()?.dispatch(...params);
    }, 100);
    return;
  }
  return store.dispatch(...params) as any;
};

export const getStateOutsideOfComponent = async (): Promise<ReduxState> => {
  let store = getStore();
  while (!store) {
    await waitAsync(100);
    store = getStore();
  }
  return store.getState();
};

// You can use subscribe() to update the UI in response to state changes.
// Normally you'd use a view binding library (e.g. React Redux) rather than subscribe() directly.
// However it can also be handy to persist the current state in the localStorage.
// store.subscribe(() => console.log(store.getState()));

// if (import.meta.hot) {
//   import.meta.hot.accept(newModule => {
//     if (newModule) {
//       // newModule is undefined when SyntaxError happened
//       console.log('TSET HOT UPDATE :: STORE', newModule);
//     }
//   });
// }

// if (import.meta.hot) {
//   import.meta.hot.accept(newModule => {
//     if (newModule) {
//       // newModule is undefined when SyntaxError happened
//       console.log('TSET HOT UPDATE :: STORE', newModule);
//     }
//   });
// }
